module.exports = __webpack_public_path__ + "static/img/3530_phase_function_Paper_PointsHejduk_Prediction.1b1478e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/3530_phase_function_Paper_PointsHejduk_Prediction.png
// module id = fkR1
// module chunks = 0